import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { SalamanderDatashareRecord } from "../../../../models/SalamanderDatashare";
import { IRootState } from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import MailroomSchool from "../../../mailroom/MailroomSchool";
import Table, { TableColumn } from "../../../Table";
import TableCell from "../../../TableCell";
import { TableRowProps } from "../../../TableRow";
import SchoolPageTitle from "../../../SchoolPageTitle";
import AdminSchoolMenu from "../../../AdminSchoolMenu";

interface SalamanderInboxPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
}

interface SalamanderInboxPageState {
    dataShareRecords: SalamanderDatashareRecord[] | undefined;
}

class SalamanderInboxPage extends Component<SalamanderInboxPageProps & DispatchProps, SalamanderInboxPageState> {

    constructor(props: SalamanderInboxPageProps & DispatchProps) {
        super(props);

        this.state = {
            dataShareRecords: undefined,
        };
    }

    async componentDidUpdate(prevProps: Readonly<SalamanderInboxPageProps & DispatchProps>, prevState: Readonly<SalamanderInboxPageState>, snapshot?: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.loadDatashareRecords(this.props.tenantId, this.props.schoolCode);
        }
    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.loadDatashareRecords(this.props.tenantId, this.props.schoolCode);
        }
    }

    private async loadDatashareRecords(tenantId: string, schoolCode: string) {
        this.setState({
            dataShareRecords: undefined
        });

        const dataShareRecords = await this.props.apiService.getSalamanderDatashareRecords(tenantId, schoolCode);

        this.setState({
            dataShareRecords: dataShareRecords
        });
    }


    private dataShareColumns: TableColumn[] = [
        {
            title: "Workflow",
            propertyPath: "workflow",
            extraDetail: "blobName",
            flex: 4,
            enableSort: true
        },
        {
            title: "Timestamp",
            propertyPath: "timestamp",
            type: "date",
            flex: 4,
            enableSort: true
        },
        {
            title: "Completed",
            extraDetail: "Not currently implemented",
            propertyPath: "completed",
            flex: 4,
            enableSort: true
        }
    ];

    private dataShareBuildRow = (row: SalamanderDatashareRecord, column: TableColumn, index: number): JSX.Element | undefined => {
        if (column.propertyPath === "workflow") {
            return (
                <TableCell key={index} flex={column.flex}>
                    <span>{row.workflow}</span>
                    <span className={"cdb-table__extra-detail"}>{row.blobName}</span>
                </TableCell>
            );
        }
    }

    private dataShareRowProps = (row: SalamanderDatashareRecord): TableRowProps => {
        return {
            to: `/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/inbox/${row.blobName}`,
            enableRowLink: true
        };
    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Salamander Inbox" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <MailroomSchool schoolCode={this.props.schoolCode} tenantId={this.props.tenantId} />
                <Table
                    title={"Salamader Records"}
                    items={this.state.dataShareRecords == undefined ? [] : this.state.dataShareRecords}
                    loading={this.state.dataShareRecords == undefined}
                    emptyMessage="No records found"
                    columns={this.dataShareColumns}
                    cellForColumn={this.dataShareBuildRow}
                    rowPropsForItem={this.dataShareRowProps}
                    enableSort={true}>
                </Table>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): SalamanderInboxPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,

            apiService: state.auth.apiService
        };
    }
)(SalamanderInboxPage);